import Parseable from '@/misc/Parseable';

/**
 * GridFS file ids of the taxi images, keyed by slot
 */
export interface TaxiImages {
    main?: string,
    mainThumb?: string,
    front?: string,
    right?: string,
    back?: string,
    left?: string,
    backSeat?: string,
    frontSeat?: string
}

export default class Taxi extends Parseable {
    public id!: string;
    public plate!: string;
    public seats!: number;
    public taxiNo!: string;
    public type!: string;
    public suggestedDriver!: string;
    public privateDrive?: string;
    public permitOwnerName?: string;
    public permitNo?: string;
    public carVehicleRegisterNo?: string;
    public images?: TaxiImages;

    public static parseFromObject(object: Partial<Taxi>): Taxi {
        const taxi = new Taxi();
        Object.assign(taxi, object);
        return taxi;
    }

    public parseToObject(): Partial<Taxi> {
        const tmp = { ...this };
        return tmp;
    }
}
